import { toTypedSchema } from "@vee-validate/zod"
import { useForm } from "vee-validate"
import z from "zod"
import { requiredNonBlankString } from "@/validation/sharedStringFieldSchemas"

const setChangeResetPasswordFormSchema = z
  .object({
    currentPassword: requiredNonBlankString(
      "Current password is required"
    ).optional(),
    password: z
      .string()
      .min(8, "Password must be at least 8 characters")
      .refine((value) => value.trim().length > 0, {
        message:
          "Password must include a non-space character",
      }),
    confirmPassword: requiredNonBlankString(
      "Please confirm your password"
    ),
  })
  .superRefine(({ password, confirmPassword }, context) => {
    if (password !== confirmPassword) {
      context.addIssue({
        path: ["confirmPassword"],
        code: "custom",
        message: "Passwords do not match",
      })
    }
  })

export type SetChangeResetPasswordFormInput =
  TypedSchemaInput<typeof setChangeResetPasswordFormSchema>

export type SetChangeResetPasswordFormOutput =
  TypedSchemaOutput<typeof setChangeResetPasswordFormSchema>

export const useSetChangeResetPasswordForm = () =>
  useForm({
    validationSchema: toTypedSchema(
      setChangeResetPasswordFormSchema
    ),
    initialValues: {
      currentPassword: undefined,
      password: "",
      confirmPassword: "",
    },
  })
